import React, { useCallback } from 'react';
import { useSelector } from 'react-redux';
import { useAuthContext } from 'react-structure-admin';
import { ROLE_ADMIN } from 'constants/types';

const useAuth = (getKey = null) => {
  const auth = useAuthContext(getKey);
  const data = useSelector((state) => state.auth);

  const hasRole = useCallback(
    (...roles) => data.user.roles.some((role) => roles.includes(role)),
    [auth.refreshToken]
  );

  const hasAccountType = useCallback(
    (...types) =>
      data.user.tenants.some((account) => types.includes(account.type)),
    [auth.refreshToken]
  );

  const hasFeature = useCallback(
    (...features) =>
      data.features.some((feature) => features.includes(feature)),
    [auth.refreshToken]
  );

  const isAdmin = useCallback(
    () => data?.user?.roles?.some((role) => role === ROLE_ADMIN) ?? false,
    [auth.refreshToken]
  );

  return {
    ...auth,
    authenticating: data?.authenticating ?? false,
    serviceProvider: auth?.user?.serviceProvider,
    company: auth?.company,
    hasRole,
    hasFeature,
    hasAccountType,
    isAdmin
  };
};

export default useAuth;
